import * as React from "react";

export function EmailP(props) {
  return (
    <svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M27.188 4.688H2.813a.936.936 0 00-.938.937v18.75c0 .519.419.938.938.938h24.375a.936.936 0 00.937-.938V5.625a.936.936 0 00-.938-.938zm-2.368 3.19l-9.243 7.192a.63.63 0 01-.776 0L5.555 7.878a.21.21 0 01.129-.378H24.69a.211.211 0 01.13.378z"
        fill="currentColor"
        fillOpacity={0.6}
      />
    </svg>
  );
}
